import { alpha } from '@mui/material';

// ==============================|| TABLE OVERRIDES ||============================== //

export default function Table(theme) {
  return {
    // MuiTablePagination: {
    //   styleOverrides: {
    //     toolbar: {
    //       '& .MuiIconButton-root': {
    //         padding: 8
    //       }
    //     },
    //     select: {
    //       '&:focus': {
    //         backgroundColor: 'transparent'
    //       }
    //     }
    //   }
    // },
    // MuiToolbar: {
    //   styleOverrides: {
    //     root: {
    //       minHeight: '0 !important',
    //       padding: '0 !important'
    //     }
    //   }
    // },
    MuiTableRow: {
      styleOverrides: {
        head: {
          // background: theme.palette.black[10]
        },
        root: {
          transition: 'background-color .2s',
          '&.MuiTableRow-hover:hover': {
            // backgroundColor: theme.palette.black[10]
          }
        }
      }
    },
    // MuiTableCell: {
    //   styleOverrides: {
    //     root: {
    //       borderBottomColor: colors.alpha.black[10],
    //       fontSize: 14
    //     },
    //     head: {
    //       textTransform: 'uppercase',
    //       fontSize: 13,
    //       fontWeight: 'bold',
    //       color: colors.alpha.black[70]
    //     }
    //   }
    // },
    MuiTableCell: {
      styleOverrides: {
        // root: {
        //   borderBottomColor: theme.palette.black[10],
        //   fontSize: 14
        // },
        head: {
          // color: theme.palette.text.secondary,
          // backgroundColor: theme.palette.background.neutral,
        },
      },
    },
  };
}
